<script lang="ts">
	import { format } from 'svelte-i18n';
	// Stores
	import { rooms } from 'src/stores/lists/rooms';
	// Helpers
	import { defaultHiddenDevicesRoom, defaultSelectedRoom } from '../helpers/constants';
	import { sortBy } from './Lists/list-helpers';
	// Design system components
	import { Select } from '@Shelly/shelly-design-system';
	import { onDestroy } from 'svelte';
	import {
		roomsGroupsFilter,
		roomsGroupsFilterInitialState,
		roomsScenesFilter,
		roomsScenesFilterInitialState,
	} from 'src/stores/ui/filters';

	export let customRooms = [];
	export let disabled = false;
	export let appliedFilters;

	const serviceRoom = [
		{
			title: $format('hidden_devices', { default: 'hidden devices' }),
			value: -10,
			translationDefault: 'hidden devices',
		},
	];

	$: orderedRooms = Object.values($rooms)
		.sort((x, y) => {
			return sortBy(x, y, 'position');
		})
		.map((room: any) => {
			return {
				title: room.name,
				value: room.id,
			};
		});

	const defaultSelectedRoomTranslated = {
		...defaultSelectedRoom,
		title: $format(defaultSelectedRoom.title, {
			default: defaultSelectedRoom.translationDefault,
		}),
	};

	const defaultHiddenDevicesRoomTranslated = {
		...defaultHiddenDevicesRoom,
		title: $format(defaultHiddenDevicesRoom.title, {
			default: defaultHiddenDevicesRoom.translationDefault,
		}),
	};

	const mappedTranslatedValues = {
		[defaultSelectedRoom.value as any]: defaultSelectedRoomTranslated,
		[defaultHiddenDevicesRoom.value as any]: defaultHiddenDevicesRoomTranslated,
	};

	$: roomsOptions = [
		defaultSelectedRoomTranslated,
		...customRooms,
		...(orderedRooms && [...orderedRooms]),
		...serviceRoom,
	];

	$: value =
		mappedTranslatedValues[appliedFilters.rooms.find((filter) => filter.title).value] ||
		appliedFilters.rooms.find((filter) => filter.title).title;

	const resetData = () => {
		appliedFilters.rooms = [defaultSelectedRoom];
	};

	onDestroy(() => {
		roomsGroupsFilter.set({ ...roomsGroupsFilterInitialState });
		roomsScenesFilter.set({ ...roomsScenesFilterInitialState });
	});
</script>

<svelte:window on:reset={resetData} />

<Select
	class="width-md-l width-sm-full"
	id="select-room-filter"
	aria-labelledby="select-room-filter"
	bind:value
	on:change={(e) => {
		appliedFilters.rooms = [e.detail];
	}}
	on:change
	options={roomsOptions}
	icon="fas fa-door-open"
	label={$format('all_rooms')}
	disabled={disabled ||
		appliedFilters?.shared_devices?.find((filter) => {
			return filter.id === 'shared' && filter.selected;
		})}
/>
